import styled from 'styled-components'

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  padding: 16px;
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
  border-radius: 0 0 8px 8px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const PaginationInfo = styled.div`
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }
`

export const PageIndicator = styled.span`
  font-size: 13px;
  color: #007bff;
  font-weight: 600;
  background-color: #e3f2fd;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #bbdefb;
  white-space: nowrap;
`

export const PaginationControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
  }

  /* Enhanced active page styling */
  .pagination .page-item.active .page-link {
    background-color: #007bff !important;
    border-color: #007bff !important;
    color: white !important;
    font-weight: bold !important;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3) !important;
  }

  .pagination .page-item.active .page-link:hover {
    background-color: #0056b3 !important;
    border-color: #0056b3 !important;
  }

  /* Improve hover state for non-active pages */
  .pagination .page-item:not(.active) .page-link:hover {
    background-color: #e9ecef;
    border-color: #dee2e6;
    color: #007bff;
  }

  /* Make pagination items more distinct */
  .pagination .page-link {
    border: 1px solid #dee2e6;
    color: #6c757d;
    font-weight: 500;
    min-width: 40px;
    text-align: center;
  }
`

export const LimitSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  label {
    color: #6c757d;
    font-weight: 500;
    margin: 0;
  }

  select {
    padding: 4px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
    color: #495057;
    background-color: white;
    min-width: 70px;

    &:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }
`
